module.exports = __webpack_public_path__ + "3c57f4fd61db7fe7cadc326fc6343bf0.pdf";